import React from "react";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import Tooltip from "@material-ui/core/Tooltip";

const CopyableText = ({ text, onCopy }) => {

  const handleCopy = (e) => {
    e.stopPropagation();        // only stop for icon
    e.preventDefault();

    navigator.clipboard.writeText(text);

    if (onCopy) {
      onCopy();
    }
  };

  return (
    <span
      style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        width: "100%",          // let row click pass
      }}
    >
      <span>{text}</span>

      <Tooltip title="Copy">
        <FileCopyIcon
          fontSize="small"
          onClick={handleCopy}
          style={{
            cursor: "pointer",
            color: "#666",
            pointerEvents: "auto",
          }}
        />
      </Tooltip>
    </span>
  );
};

export default CopyableText;